$(document).on('click', '.cart-summary-overlay__title a, .cart-summary-overlay__column-image a', function(e) {
  e.stopPropagation(); // stop other JS from intercepting
  window.location.href = $(this).attr('href');
});


jQuery(document).ready(function($) {
  var $sizeOptions = $('.option-selector__btns.sizeOption input.js-option');
  var $addToCartBtn = $('#AddToCart');
  var $message = $addToCartBtn.siblings('.variant-warning');

  // Reset radios and visually disable button
  $sizeOptions.prop('checked', false);
  $addToCartBtn.addClass('disabled');  // just styling
  $message.hide();

  // Enable button visually on selection
  $sizeOptions.on('change', function() {
    if ($sizeOptions.is(':checked')) {
      $addToCartBtn.removeClass('disabled');
      $message.removeClass('show');  // hide message when size selected
    } else {
      $addToCartBtn.addClass('disabled');
    }
  });

  // Intercept Add to Cart click
  $addToCartBtn.on('click', function(e) {
    if (!$sizeOptions.is(':checked')) {
      e.preventDefault();          // stop adding to cart
      $message.addClass('show');   // show the warning
      // $('html, body').animate({ scrollTop: $message.offset().top - 100 }, 300);
    }
  });
});

document.querySelector("#custom-add-to-cart").addEventListener("click", () => {
  let variantArr = [];
  let selectOption = document.querySelectorAll(".variant-select");
  selectOption.forEach((item) => {
    variantArr.push(item[item.selectedIndex].value);
  });
  customAddToCart(variantArr);
});

function customAddToCart(variantIds) {
  let formData = {
    items: variantIds.map((item) => {
      return { id: item, quantity: 1 };
    }),
  };
  fetch(window.Shopify.routes.root + "cart/add.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(formData),
  })
    .then((response) => {
      return response.json();
    })
    .then((res) => {
      document.documentElement.dispatchEvent(
        new CustomEvent("theme:cartchanged", {
          bubbles: true,
          cancelable: false,
        })
      );
      document.querySelector(".cart-link").click();
      //console.log(res);
    })
    .catch((error) => {
      console.error("Error:", error);
    });
}


